<div class="login-holder">
  <div class="text-container mat-elevation-z8">
    <p class="centered-text">Välkommen till tjänsten fotoadmin. För att kunna använda tjänsten behöver ni först identifiera er med BankID.</p>
    <aku-bankid [bankIdUrl]="bankIdUrl" (accessToken)="configService.setToken($event)"></aku-bankid>
  </div>
</div>

